import { forwardRef } from 'react';
import Loading from '~/components/misc/loading-animation.js';
import { Spinner } from '@comeon/ui';

const ThreeDsIframe = forwardRef(({ threeDSMethodURL, updateFormAttr, encodedJSON, qdDepositFlow = false }, ref) => {
	return (
		<>
			{qdDepositFlow ? <Spinner /> : <Loading />}
			<iframe
				title="threeDS-method-frame"
				id="threeDSMethodIframe"
				name="threeDSMethodIframe"
				src=""
				style={{ display: 'none' }}
			/>
			<form method="POST" action={threeDSMethodURL} ref={ref} id="threeDSform" target="threeDSMethodIframe">
				{updateFormAttr ? (
					<>
						<input type="hidden" name="Bin" value={encodedJSON.Bin} />
						<input type="hidden" name="JWT" value={encodedJSON.JWT} />
					</>
				) : (
					<input type="hidden" name="threeDSMethodData" value={encodedJSON} />
				)}
			</form>
		</>
	);
});

export default ThreeDsIframe;
